// src/components/NotificationBar.tsx
import React from "react";
//import { cn } from '../utils/cn'; // Optional utility to join classNames

interface NotificationCardProps {
  icon: string;
  title: "Critical" | "Error" | "Warning" | "Info";
  description: string;
  details: string;
  link: string;
  timeAgo: string;
  alertName: string;
}

const borderColors = {
  Critical: "border-l-[var(--border-critical)]",
  Error: "border-l-[var(--border-error)]",
  Warning: "border-l-[var(--border-warning)]",
  Info: "border-l-[var(--border-info)]",
};




const NotificationCard: React.FC<NotificationCardProps> = ({
  icon,
  title,
  description,
  link,
  details,
  alertName,
  timeAgo,
}) => {
  return (
    <div
      className={`w-full max-w-md !bg-[var(--bg-elevated)] rounded-xl p-3 flex items-start space-x-2 border-t border-r border-b border-[var(--border-default)] border-l-4 ${borderColors[title]}` }
    >
      {/* Icon */}
      <div className="flex-shrink-0 w-10 h-10 rounded-md bg-[var(--bg-icon-muted)] flex items-center justify-center overflow-hidden">
        <img src={icon} alt="icon" className="w-6 h-6" />
      </div>

      {/* Content */}
      <div className="flex-1">
        <div className="flex justify-between items-center mb-1">
          <h4 className="text-[13px] font-semibold">{title}</h4>
          <span className="text-[11px] text-[var(--text-tertiary)]">{timeAgo}</span>
        </div>
        <p className="text-[var(--text-tertiary)] text-[10px]">{details}</p>
        <p className="text-[11px] mt-1 text-[var(--text-tertiary)]">{description}</p>
        {link ? (
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[13px] font-medium text-[var(--status-info)] hover:underline transition-colors duration-150 block"
          >
            {alertName} →
          </a>
        ) : (
          <span className="text-[13px] text-[var(--status-info)] font-medium block">
            {alertName}
          </span>
        )}
      </div>
    </div>
  );
};

export default NotificationCard;
